/**
 * The HR Portal pointer (21 Oct, Rusty): HR's part of the user process (new
 * starters, leavers) moved to Timo's HR Portal. Pure helpers, tested with
 * `node --test`.
 */

/** The types the pointer shows for: a new starter and a leaver, not a change. */
export function showsHrPortal(type: string | null | undefined): boolean {
  return type === "new" || type === "leave";
}

/** HR_PORTAL_URL as a link, or null (unset, or not an http(s) address). */
export function hrPortalHref(url: string | null | undefined): string | null {
  const trimmed = (url ?? "").trim();
  return /^https?:\/\/\S+$/i.test(trimmed) ? trimmed : null;
}
